export default defineNuxtPlugin(() => {
  const fetchWithLocale = <T>(url: string, options: any = {}) => {
    const { $i18n } = useNuxtApp()
    const { currency } = useCurrencyStore()
    const separator = url.includes('?') ? '&' : '?'
    const params = new URLSearchParams({ lang: $i18n.locale.value, cur: currency })
    const finalUrl = `${url}${separator}${params.toString()}`

    return useRequestFetch()<T>(finalUrl, options)
  }

  return {
    provide: {
      fetchWithLocale,
    },
  }
})